import * as d3 from "d3";
import {
    make_x_gridlines,
    make_y_gridlines,
    colonAnnotation,
    fw_progressive_1way,
    responsivefy,
    // tooltip_class,
    getTimeFormatter, createAxis, createTooltip, inrFormatterV2, generateDownloadData, contextMenu
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam, checkbox, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    const financialYearMonths = ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar"];

    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append('svg')
        .attr('width', chart.width + chart.margin.left + chart.margin.right)
        .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

    // Add <defs> and <clipPath> to the SVG
    svg.append("defs")
        .append("svg:clipPath")
        .attr("id", "clip1")  // Use d.key for the clipPath id
        .append("svg:rect")
        .attr("x", 0)
        .attr("y", -10)
        .attr("width", chart.width)   // Clip width matches chart width
        .attr("height", chart.height+10); // Clip height matches chart height

    // Append a group with clipPath applied
    const contentGroup = svg.append("g")
        .attr("class", "content")
        .attr("clip-path", "url(#clip1)");  // Dynamically set clip-path using d.key

    // axios.post(url, filterParam).then(response => {
        let data = resData
        // nest function allows to group the calculation per level of a factor
        var sumstat = d3.nest().key(d => {
            return d.dim1_name
        }).sortKeys(d3.ascending).entries(data)
        // Add X-axis for date and Y-axis
        // Parse date strings into Date objects
        if('timeScale'== chart.x1D3ScaleType) {
            data.forEach(function (d) {
                d[chart.x1DataFieldName] = new Date(d[chart.x1DataFieldName]);
                // console.log("kkk", d[chart.x1DataFieldName])
            });
        }
        let value1;
        let rang;

        console.log("chart from multilinechart",chart);

        switch (chart.x1D3ScaleType) {
            case "linearScale":
                value1 = [0, d3.max(data, d => d[chart.x1DataFieldName])];
                rang = [0, chart.width];
                break;

            case "bandScale":
                value1 = chart.vizSpecific6==="FY"? financialYearMonths.filter(month =>
                    data.map(d => d[chart.x1DataFieldName]===month)) : data.map(d => d[chart.x1DataFieldName])
                rang = [0, chart.width];
                break;

            case "timeScale":
                value1 = d3.extent(data, d => d[chart.x1DataFieldName]);
                rang = [0, chart.width];
                break;

            default:
                // Handle any other cases or provide a default behavior
                console.error("Invalid x1D3ScaleType:", chart.x1D3ScaleType);
        }

        if (value1 && rang) {
        // Create time scale
            var x1Scale = createAxis(chart.x1D3ScaleType).domain(value1).range(rang);

        const dim4Names = data.map(d => d.dim3_name);
        const firstDim4Name = dim4Names[0];
        var formatTime = getTimeFormatter(firstDim4Name)
        var y1Scale = d3.scaleLinear().domain([(function() {
            var minVal = d3.min(data, function(d) {
                return d.y1DataFieldName;
            });
            return (minVal < 0) ? minVal : 0;
        })(), d3.max(data, d => {
            return d[chart.y1DataFieldName]
        })]).range([chart.height, 0])

            // if(chart.x1D3ScaleType=='timeScale' )
            // {
            //     xaxis=d3.axisBottom(x1Scale).tickValues(x1Scale.domain().filter(function (d, i) {
            //         return chart.vizSpecific4 == 'continous' ? !(i % 3) : !(i % 1)
            //     }))
            // }
            // else{
            //     xaxis=d3.axisBottom(x1Scale)
            //         .tickValues(x1Scale.ticks(d3.timeMonth.every(1)).concat(x1Scale.domain()[0])) // Concatenate the existing ticks with the first date in your domain
            //         .tickFormat(formatTime)
           // }

           var xAxis;
            if("timeScale" == chart.x1D3ScaleType) {
                // Define the axes
                xAxis =  d3.axisBottom(x1Scale)
                    .tickValues(x1Scale.ticks(d3.timeMonth.every(1)).concat(x1Scale.domain()[0])) // Concatenate the existing ticks with the first date in your domain
                    .tickFormat(formatTime)
            }
            else if('bandScale'== chart.x1D3ScaleType){
                xAxis=d3.axisBottom(x1Scale).tickValues(x1Scale.domain().filter(function (d, i) {
                    return chart.vizSpecific4 == 'continous' ? !(i % 3) : !(i % 1)
                }))
            }else if('linearScale'== chart.x1D3ScaleType){
                xAxis=d3.axisBottom(x1Scale).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)})
            }

        svg.append('text')
            .attr('x', (chart.width / 2.5))
            .attr('y', chart.height + chart.margin.bottom - chart.margin.top - 30)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - (chart.margin.right / 2))
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('g')
            .attr("class","y-axis")
            .call(d3.axisLeft(y1Scale).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)}))
            .selectAll('text')
            .style('font-size', axisLabelFontSize)

                svg.append('g')
                    .attr("class","x-axis")
                    .attr('transform', 'translate(0,' + chart.height + ')')
                    .call(xAxis)
                    //.call(d3.axisBottom(x1Scale))
                    .selectAll('text')
                    .style('font-size', axisLabelFontSize)
                    .style('text-anchor', 'end')
                    .attr('dx', '-.6em')
                    .attr('dy', '-.0em')
                    .attr('transform', 'rotate(-60)')


        if (gridflag == true) {
            // add the X gridlines
            svg.append("g")
                .attr("class", "grid")
                .attr("transform", "translate(0," + chart.height + ")")
                .call(make_x_gridlines(x1Scale).ticks(d3.timeMonth.every(1))
                    .tickSize(-chart.height)
                    .tickFormat(""))
                .style("stroke-width", 0.1)

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1Scale)
                    .tickSize(-chart.width)
                    .tickFormat(""))
                .style("stroke-width", 0.1)
        }

        // color palette
        var res = sumstat.map(d => {
            return d.key
        }) // list of group main category
        var metric1ColorScale = d3.scaleOrdinal().domain(res).range(fw_progressive_1way)


            if("timeScale" == chart.x1D3ScaleType || 'linearScale'==chart.x1D3ScaleType) {
                // Draw the line
                contentGroup.selectAll('.line')
                    .data(sumstat)  // Binds data to the line
                    .join("path")
                    .attr("class", "line")
                    .attr('fill', 'none')
                    .attr('stroke', d => {
                        return metric1ColorScale(d.key)
                    })
                    .attr('stroke-width', 3)
                    .attr('d', (d) => {
                        let line = d3.line()
                            .x(d => {
                                return x1Scale(d[chart.x1DataFieldName])
                            })
                            .y(d => {
                                return y1Scale(+d[chart.y1DataFieldName])
                            })

                        return line(d.values)
                    })
                //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding


                const tooltip = createTooltip(divId);

                // Add the dots for the tooltip
                // d3.select(".d3-tip" + divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
                // var y1tip = tooltip_class()
                // if (chart.x1D3ScaleType == 'timeScale') {
                //     y1tip.attr('class', 'd3-tip' + divId.id)
                //         .html((d) => {
                //             return chart.x1MetricTooltip + colonAnnotation + formatTime(d[chart.x1DataFieldName]) + "<br/>" + chart.x2MetricTooltip
                //                 + colonAnnotation + d.dim1_name + "<br/>" + chart.y1MetricTooltip + colonAnnotation + numberFormat(d[chart.y1DataFieldName])
                //         })
                // } else if(chart.x1D3ScaleType == 'bandScale') {
                //     y1tip.attr('class', 'd3-tip' + divId.id)
                //         .html((d) => {
                //             return chart.x1MetricTooltip + colonAnnotation + d[chart.x1DataFieldName] + "<br/>" + chart.x2MetricTooltip
                //                 + colonAnnotation + d.dim1_name + "<br/>" + chart.y1MetricTooltip + colonAnnotation + numberFormat(d[chart.y1DataFieldName])
                //         })
                // }else if(chart.x1D3ScaleType == 'linearScale'){
                //     y1tip.attr('class', 'd3-tip' + divId.id)
                //         .html((d) => {
                //             return chart.x1MetricTooltip + colonAnnotation + numberFormat(d[chart.x1DataFieldName]) + "<br/>" + chart.x2MetricTooltip
                //                 + colonAnnotation + d.dim1_name + "<br/>" + chart.y1MetricTooltip + colonAnnotation + numberFormat(d[chart.y1DataFieldName])
                //         })
                // }

                // svg.call(y1tip);

                contentGroup.selectAll(".dot")
                    .data(data)
                    .join("circle")
                    .attr("class","dot")
                    .attr("r", 5)
                    .attr("cx", function (d) {
                        return x1Scale(d[chart.x1DataFieldName]);
                    })
                    .attr("cy", function (d) {
                        return y1Scale(d[chart.y1DataFieldName]);
                    })
                    .style("fill", d => {
                        return metric1ColorScale(d.dim1_name)
                    })
                    .on('mouseover', function(d) {
                        const fontColor =  metric1ColorScale(d.dim1_name);
                        tooltip.onMouseOver(d, this, function(d) {
                            if (chart.x1D3ScaleType === 'timeScale') {
                                return chart.x1AxisDisplayName + colonAnnotation + formatTime(d[chart.x1DataFieldName]) + "<br/>" +
                                    "Type" + colonAnnotation + d.dim1_name + "<br/>" +
                                    chart.y1AxisDisplayName + colonAnnotation + inrFormatterV2(d[chart.y1DataFieldName],chart.data.menuId);
                            } else if (chart.x1D3ScaleType === 'bandScale') {
                                return chart.x1AxisDisplayName + colonAnnotation + d[chart.x1DataFieldName] + "<br/>" +
                                    "Type" + colonAnnotation + d.dim1_name + "<br/>" +
                                    chart.y1AxisDisplayName + colonAnnotation + inrFormatterV2(d[chart.y1DataFieldName],chart.data.menuId);
                            } else if (chart.x1D3ScaleType === 'linearScale') {
                                return chart.x1AxisDisplayName + colonAnnotation + inrFormatterV2(d[chart.x1DataFieldName],chart.data.menuId) + "<br/>" +
                                    "Type" + colonAnnotation + d.dim1_name + "<br/>" +
                                    chart.y1AxisDisplayName + colonAnnotation + inrFormatterV2(d[chart.y1DataFieldName],chart.data.menuId);
                            }
                        },fontColor);  // Pass the event for accurate positioning
                    })
                    .on('mousemove', function(event) {
                        tooltip.onMouseMove(event);  // Use the event for updating the tooltip position
                    })
                    .on('mouseleave', function() {
                        tooltip.onMouseLeave();  // Hide the tooltip when mouse leaves
                    })
                    .on('contextmenu', function(d) {

                    // Prepare clickedData with both axes' info
                    const clickedData = {
                        [chart.x1DataFieldName]: [d[chart.x1DataFieldName]],  // e.g., "2019", "2020"
                        dim1_name: [d.dim1_name],               // e.g., "metric1"
                        // yAxisValue: inrFormatterV2(d[chart.y1DataFieldName],chart.data.menuId)               // e.g., 5000
                    };
                    // Generate the menu with current config and filters
                    const menuItems = generateDownloadData(chart.insightNavigator, filterParam);

                    // Show the context menu
                    contextMenu(menuItems).call(this, clickedData);

                    // Prevent default context menu
                    d3.event.preventDefault();
                });

            }
            else{
                // Draw the line
                contentGroup.selectAll('.line')
                    .data(sumstat)  // Binds data to the line
                    .join("path")
                    .attr("class", "line")
                    .attr('fill', 'none')
                    .attr('stroke', d => {
                        return metric1ColorScale(d.key)
                    })
                    .attr('stroke-width', 3)
                    .attr('d', (d) => {
                        let line = d3.line()
                            .x(d => {
                                return x1Scale(d[chart.x1DataFieldName]) + x1Scale.bandwidth()/2
                            })
                            .y(d => {
                                return y1Scale(+d[chart.y1DataFieldName])
                            })

                        return line(d.values)
                    })
                //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding


                // Add the dots for the tooltip
                // d3.select(".d3-tip" + divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
                //  y1tip = tooltip_class()
                // if (chart.x1D3ScaleType == 'timeScale') {
                //     y1tip.attr('class', 'd3-tip' + divId.id)
                //         .html((d) => {
                //             return chart.x1MetricTooltip + colonAnnotation + formatTime(d[chart.x1DataFieldName]) + "<br/>" + chart.x2MetricTooltip
                //                 + colonAnnotation + d.dim1_name + "<br/>" + chart.y1MetricTooltip + colonAnnotation + numberFormat(d[chart.y1DataFieldName])
                //         })
                // } else {
                //     y1tip.attr('class', 'd3-tip' + divId.id)
                //         .html((d) => {
                //             return chart.x1MetricTooltip + colonAnnotation + d[chart.x1DataFieldName] + "<br/>" + chart.x2MetricTooltip
                //                 + colonAnnotation + d.dim1_name + "<br/>" + chart.y1MetricTooltip + colonAnnotation + numberFormat(d[chart.y1DataFieldName])
                //         })
                // }
                // svg.call(y1tip);

                const tooltip1 = createTooltip(divId);

                contentGroup.selectAll(".dot")
                    .data(data)
                    .join("circle")
                    .attr("class","dot")
                    .attr("r", 5)
                    .attr("cx", function (d) {
                        return x1Scale(d[chart.x1DataFieldName])+ x1Scale.bandwidth()/2;
                    })
                    .attr("cy", function (d) {
                        return y1Scale(d[chart.y1DataFieldName]);
                    })
                    .style("fill", d => {
                        return metric1ColorScale(d.dim1_name)
                    })
                    .on('mouseover', function(d) {
                        const fontColor =  metric1ColorScale(d.dim1_name);
                        tooltip1.onMouseOver(d, this, function(d) {
                            if (chart.x1D3ScaleType === 'timeScale') {
                                return chart.x1AxisDisplayName + colonAnnotation + formatTime(d.dim2_name) + "<br/>" +
                                    "Type" + colonAnnotation + d.dim1_name + "<br/>" +
                                    chart.y1AxisDisplayName + colonAnnotation + inrFormatterV2(d.metric1,chart.data.menuId);
                            } else {
                                return chart.x1AxisDisplayName + colonAnnotation + d[chart.x1DataFieldName] + "<br/>" +
                                    "Type" + colonAnnotation + d.dim1_name + "<br/>" +
                                    chart.y1AxisDisplayName + colonAnnotation + inrFormatterV2(d[chart.y1DataFieldName],chart.data.menuId);
                            }
                        },fontColor);  // Pass the event for positioning
                    })
                    .on('mousemove', function(event) {
                        tooltip1.onMouseMove(event);  // Use event for updating position
                    })
                    .on('mouseleave', function() {
                        tooltip1.onMouseLeave();  // Hide tooltip on mouse leave
                    })
                    .on('contextmenu', function(d) {

                        // Prepare clickedData with both axes' info
                        const clickedData = {
                            [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]:[d.dim2_name],  // e.g., "2019", "2020"
                            [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name],               // e.g., "metric1"
                            // yAxisValue: inrFormatterV2(d[chart.y1DataFieldName],chart.data.menuId)               // e.g., 5000
                        };
                        // Generate the menu with current config and filters
                        const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                        // Show the context menu
                        contextMenu(menuItems).call(this, clickedData);

                        // Prevent default context menu
                        d3.event.preventDefault();
                    });
            }

        var y1legend = svg.append('g')
            .attr('class', 'legend')
            .selectAll('g')
            .data(sumstat)
            .enter()
            .append('g')
            .attr('transform', function (d, i) {
                var horz = -chart.margin.left; // Adjust as needed
                var vert = i * 40; // Spacing between legend items
                return 'translate(' + horz + ',' + vert + ')';
            });

        y1legend.append('rect')
            .attr('x', chart.width + chart.margin.right - 60)
            .attr('y', 10)
            .attr('width', 25)
            .attr('height', 25)
            .attr('fill', d => metric1ColorScale(d.key));

        y1legend.append('text')
            .data(sumstat, (d) => d.key)
            .attr('x', chart.width + chart.margin.right - 30)
            .attr('y', 23) // Adjust as needed for vertical alignment
            .attr('dy', '0.35em')
            .text((d) => d.key.length > 7 ? d.key.substring(0, 7) + "~ " : d.key)
            .style('font-size', '25px'); // Adjust font size as needed
    }
        var zoomBehaviour = d3.zoom().scaleExtent([1,10]).on("zoom",zoomed);

        function zoomed(){
                var zoomState = d3.zoomTransform(this);
                var newXScale ;
                var newXAxis ;

                var newYScale = zoomState.rescaleY(y1Scale);


            // Determine the x-axis settings based on the scale type
            if ("timeScale" === chart.x1D3ScaleType) {

                newXScale = zoomState.rescaleX(x1Scale);
                newXAxis = d3.axisBottom(newXScale)
                    .tickFormat(formatTime)

            }
            else if ("bandScale" === chart.x1D3ScaleType) {
                newXScale = x1Scale.range([0,zoomState.k*(chart.width - chart.margin.right)]);
                newXAxis = d3.axisBottom(newXScale)
                    .tickValues(newXScale.domain().filter((d, i) =>
                        chart.vizSpecific4 === 'continous' ? !(i % 3) : !(i % 1)
                    ));
            }
            else if ("linearScale" === chart.x1D3ScaleType) {
                newXScale = zoomState.rescaleX(x1Scale);
                newXAxis = d3.axisBottom(newXScale)
                    .tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)});
            }

            // Apply the xAxis to the x-axis element in the SVG
            svg.select(".x-axis").call(newXAxis)
                    .selectAll('text')
                    .style('font-size', axisLabelFontSize)
                    .style('text-anchor', 'end')
                    .attr('dx', '-.6em')
                    .attr('dy', '-.0em')
                    .attr('transform', 'rotate(-60)')

                svg.select(".y-axis").call(d3.axisLeft(newYScale).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)}))
                    .selectAll('text')
                    .style('font-size', axisLabelFontSize)

                // Update the second line path (if you have more lines)
                contentGroup.selectAll(".line")
                    .attr('d', (d) => {
                        let line = d3.line()
                            .x(d => {
                                return newXScale(d[chart.x1DataFieldName])
                            })
                            .y(d => {
                                return newYScale(+d[chart.y1DataFieldName])
                            })

                        return line(d.values)
                    })

                // Update the circles (dots) to move accordingly
                contentGroup.selectAll(".dot")
                    .attr("cx", function (d) {
                        return newXScale(d[chart.x1DataFieldName]);
                    })
                    .attr("cy", function (d) {
                        return newYScale(d[chart.y1DataFieldName]);
                    })
        }

        // Apply zoom to the SVG
        contentGroup.insert("rect","circle")
            .attr("width",chart.width)
            .attr("height",chart.height)
            .attr("fill","none")
            .attr("pointer-events","all")
            .call(zoomBehaviour);
    // })
}

